import { getClientSupport } from '@electronicpartnerio/ui-utils';

const browserWarning = (el: HTMLElement) => {
    const init = () => {
        const clientSupport = getClientSupport({
            win: true,
            mf: true
        });
        if (!clientSupport.supported) {
            el.style.display = 'block';
        }
    };

    setTimeout(init, 400);
};

export default browserWarning;
